import api from '@/client/core/api'
import { TableSettingsResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * GET /twitter_benchmark_campaign_posts/table_settings/:groupId
 */
export async function getTwBenchmarkTableSettings(
  groupId: number
): Promise<TwBenchmarkApiResult<TableSettingsResponse>> {
  const response = await api.get<TwBenchmarkApiResponse<TableSettingsResponse>>(
    `/twitter_benchmark_campaign_posts/table_settings/${groupId}`
  )

  return handleApiResponse<TableSettingsResponse>(response)
}
